import React from 'react';
import {formatTimestamp, formatTimestampFull, isWithinRelativeWindow} from '../utils/formatTimestamp';
import useRelativeTimeTick from '../utils/useRelativeTimeTick';

/**
 * Renders a compact timestamp ("June 15, 2026, 12:00 PM") while exposing the
 * verbose, timezone-aware value ("June 15, 2026, 12:00:00 PM UTC") on hover via
 * the native title tooltip.
 *
 * While the value is <24h old, subscribes to the shared 30s ticker so the
 * relative label ("2m ago") advances without a prop change; once it ages into
 * the absolute-format window the label is static, so ticking stops.
 *
 * Props:
 * - value: any date-like value accepted by formatTimestamp/toDate
 * - fallback: string rendered when value is missing/invalid (default "–")
 * - component: element type to render (default "span")
 * - ...rest: forwarded to the rendered element (className, style, etc.)
 */
export default function Timestamp({value, fallback = '–', component: Component = 'span', ...rest}) {
    useRelativeTimeTick(isWithinRelativeWindow(value));

    const short = formatTimestamp(value, fallback);
    const full = formatTimestampFull(value, fallback);
    return (
        <Component title={full} {...rest}>
            {short}
        </Component>
    );
}
